import api from './api';
import { API_ENDPOINTS } from '../constants';

export interface TelegramUser {
  id: number;
  chatId: number;
  hasAccess?: boolean;
}

export interface TelegramUsersApiResponse {
  items: TelegramUser[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface TelegramUsersListResponse {
  data: TelegramUser[];
  current_page: number;
  last_page: number;
  per_page: number;
  total?: number;
}

export interface TelegramUserCreateData {
  chatId: number;
}

export interface TelegramUserUpdateData {
  chatId?: number;
  hasAccess?: boolean;
}

export const telegramUserService = {
  /** GET /api/v1/admin/telegram-users — список (page, limit) */
  getList: async (page: number = 1, limit: number = 10): Promise<TelegramUsersListResponse> => {
    const { data } = await api.get<TelegramUsersApiResponse>(API_ENDPOINTS.TELEGRAM_USERS_LIST, {
      params: { page, limit },
    });
    return {
      data: Array.isArray(data.items) ? data.items : [],
      current_page: data.page,
      last_page: data.totalPages,
      per_page: data.pageSize,
      total: data.totalCount,
    };
  },

  /** GET /api/v1/admin/telegram-users/{id} */
  get: async (id: number): Promise<TelegramUser> => {
    const { data } = await api.get<TelegramUser>(API_ENDPOINTS.TELEGRAM_USER_GET(id));
    return data;
  },

  /** POST /api/v1/admin/telegram-users */
  create: async (data: TelegramUserCreateData): Promise<TelegramUser> => {
    const { data: result } = await api.post<TelegramUser>(API_ENDPOINTS.TELEGRAM_USERS_LIST, data);
    return result;
  },

  /** PATCH /api/v1/admin/telegram-users/{id} */
  update: async (id: number, data: TelegramUserUpdateData): Promise<TelegramUser> => {
    const body: Record<string, unknown> = {};
    if (data.chatId !== undefined) body.chatId = data.chatId;
    if (data.hasAccess !== undefined) body.hasAccess = data.hasAccess;
    const { data: result } = await api.patch<TelegramUser>(
      API_ENDPOINTS.TELEGRAM_USER_GET(id),
      body
    );
    return result;
  },

  /** DELETE /api/v1/admin/telegram-users/{id} */
  delete: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.TELEGRAM_USER_GET(id));
  },
};
